<app-picking-list-menu></app-picking-list-menu>

<div class="container">
    <div class="row">
        <div class="col-6">
            <div class="card p-3">
                <app-picking-list-actions [mode]="'pick'"
                                          (pickingListEvent)="getPickingLists()"></app-picking-list-actions>
            </div>
        </div>
        <div class="col-6">
            <div class="card p-3">
                <app-picking-list-actions [mode]="'pack'"
                                          (pickingListEvent)="getPickingLists()"></app-picking-list-actions>
            </div>
        </div>

        <div class="col-12">

            <h4>Pluklister</h4>
            <app-spinner *ngIf="loading"></app-spinner>
            <table class="table table-bordered table-striped" *ngIf="!loading">
                <thead>
                <tr>
                    <th>ID</th>
                    <th>Bord</th>
                    <th>Oprettet</th>
                    <th>Antal varelinjer</th>
                    <th>Pluk start</th>
                    <th>Pluk stop</th>
                    <th>Pak start</th>
                    <th>Pak stop</th>
                </tr>
                </thead>
                <tbody>
                <ng-container *ngFor="let pickingList of pickingLists ">

                    <tr>
                        <td class="text-nowrap"
                            [ngClass]="{'group-1': pickingList.picking_group === 1, 'group-2': pickingList.picking_group === 2}">
                            <a href="javascript:void(0)" (click)="showShipmentsModal(pickingList)" class="text-white">
                            {{ pickingList.id }}
                            </a>
                        </td>
                        <td class="text-nowrap">{{ pickingList?.user?.name }}</td>
                        <td class="text-nowrap">{{ pickingList.created | date:'dd.MM.YYYY HH:mm:ss' }}
                            ({{ pickingList.initials ? pickingList.initials : '-' }})
                        </td>
                        <td class="text-nowrap">
                            {{ pickingList._totalLines }}
                        </td>
                        <td class="text-nowrap">
                            <app-picking-list-status [pickingList]="pickingList"
                                                     [event]="'picking_started'"></app-picking-list-status>
                        </td>
                        <td class="text-nowrap">
                            <app-picking-list-status [pickingList]="pickingList"
                                                     [event]="'picking_completed'"></app-picking-list-status>
                        </td>
                        <td class="text-nowrap">
                            <app-picking-list-status [pickingList]="pickingList"
                                                     [event]="'packing_started'"></app-picking-list-status>
                        </td>
                        <td class="text-nowrap">
                            <app-picking-list-status [pickingList]="pickingList"
                                                     [event]="'packing_completed'"></app-picking-list-status>
                        </td>
                    </tr>
                </ng-container>


                </tbody>
            </table>
        </div>

        <div class="mt-3" *ngIf="!loading">
            <ngb-pagination
                    [ellipses]="true"
                    [page]="pageNr"
                    [pageSize]="100"
                    [maxSize]="10"
                    [collectionSize]="totalItems">
                <ng-template ngbPaginationPages let-page let-pages="pages" let-disabled="disabled">
                    <li *ngFor="let pageNumber of pages" class="page-item" [class.active]="pageNumber === page"
                        [class.disabled]="pageNumber === -1 || disabled" [attr.aria-current]="(pageNumber === page ? 'page' : null)">
                        <a *ngIf="pageNumber === -1" class="page-link" tabindex="-1" aria-disabled="true">
                            ...
                        </a>
                        <a *ngIf="pageNumber !== -1" class="page-link"
                           [routerLink]="[]"
                           [queryParams]="{page:pageNumber}" [preserveFragment]="true" [queryParamsHandling]="'merge'"
                           [attr.tabindex]="disabled ? '-1' : null" [attr.aria-disabled]="disabled ? 'true' : null">
                            {{pageNumber}}
                        </a>
                    </li>
               </ng-template>
            </ngb-pagination>
        </div>
    </div>
</div>
